const navbarWords ={
    'swipt':{'es':'Descargar Cv','en':'Download sumary'}
}

export default navbarWords;